import Container from '@mui/material/Container';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import { CompanyAccountForm } from './CompanyAccountForm';
import type { RouteComponentProps } from '@reach/router';
import { CompanyAccountWrapper } from './CompanyAccountHeader';

interface CompanyAccountPageProps extends RouteComponentProps {}

export function CompanyAccountPage(_props: CompanyAccountPageProps) {
  const { themeStretch } = useSettings();

  return (
    <Page title='Settings: Company Account | Manager'>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading='Settings'
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Settings', href: PATH_DASHBOARD.settings.root },
            { name: 'Company account settings' },
          ]}
        />
        <CompanyAccountWrapper>
          <CompanyAccountForm />
        </CompanyAccountWrapper>
      </Container>
    </Page>
  );
}
